var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnarchiveOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 8.3125V22.3125C4.37673 22.8921 4.60775 23.4475 5.01762 23.8574C5.42748 24.2672 5.98287 24.4983 6.5625 24.5H21.4375C22.0171 24.4983 22.5725 24.2672 22.9824 23.8574C23.3922 23.4475 23.6233 22.8921 23.625 22.3125V8.3125",
    stroke: "var(--ion-color-primary)",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 3.5H4.15625C3.31056 3.5 2.625 4.18556 2.625 5.03125V6.34375C2.625 7.18944 3.31056 7.875 4.15625 7.875H23.8438C24.6894 7.875 25.375 7.18944 25.375 6.34375V5.03125C25.375 4.18556 24.6894 3.5 23.8438 3.5Z",
    stroke: "var(--ion-color-primary)",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.75L14 12.25L10.5 15.75",
    stroke: "var(--ion-color-primary)",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.4591V20.125",
    stroke: "var(--ion-color-primary)",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveOutline);
export default __webpack_public_path__ + "static/media/Unarchive-outline.36fe71f2c91798fb8fe7dae967fce8e8.svg";
export { ForwardRef as ReactComponent };